import React, { useState, useEffect } from 'react';
import {
    EditBase,
    useTranslate,
    TextInput,
    SimpleForm,
    DateField,
    Labeled,
} from 'react-admin';
import { Box, Grid, Stack, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {

  TopToolbar,
  ShowButton,
  useResourceContext,
} from 'react-admin';
import alasql from "alasql";
import { generateInputField } from './factory';
import formMap from './ui/formMap';
import WorkFlowButton from './WorkFlowButton';

const EditActions = ({ basePath, data, resource, columns }) => {
  var Hooks = [];
  var workflow = 'none';
  let actions = [];

  if (typeof data !== 'undefined') {
    const role = localStorage.getItem('role');
    let stc = alasql(`select distinct StateColumn as col from workflows where Module ='${resource}' and role_${role}='control' `).map(({ col }) => col);

    if (typeof stc !== 'undefined' && typeof stc[0] !== 'undefined') {
      if (isNaN(`${data[stc[0]]}`)) {
        actions = alasql(`select * from workflows where Module ='${resource}' and role_${role}='control' and StateColumn='${stc[0]}' and StateValue='${data[stc[0]]}'`).map(col => col);
      } else {
        actions = alasql(`select * from workflows where Module ='${resource}' and role_${role}='control' and StateColumn='${stc[0]}' and StateValue='${data[stc[0]]}'`).map(col => col);
      }

      if (typeof actions[0] !== 'undefined' && typeof actions[0].Actions !== 'undefined') {
        let actData = actions[0].Actions;
        if (actData !== '[]') {
          Hooks = alasql(`select * from workflows where Module ='${resource}' and role_${role}='control' and WorkFlowName= ANY (ARRAY${actData})`).map(col => col);
          workflow = actions[0].WorkFlowName;
        }
      }
    }
  }

  return (
    <TopToolbar>
      <ShowButton basePath={basePath} record={data} />
      {Hooks.map((f, index) => <WorkFlowButton actData={f} key={index} basePath={basePath} record={data} />)}
    </TopToolbar>
  );
};

const ReviewEdit = ({ onCancel, ...props }) => {
    const translate = useTranslate();
    const resource = useResourceContext();
    const {id} = props;

    const [state, setState] = useState({
      loading: true,
      resourcesFields: [],
      resourcesTabs: [],
      resourcePermistions: [],
      tabs: [],
      canDelete: false,
      form_mode: 'UiInlineForm' // Define the form_mode variable here

    });
  

    useEffect(() => {
      const role = localStorage.getItem("role");
  
      let resourcePermistions = alasql(
        `select form_mode,inline_update from resource_permistions  where resource_name ='${resource}' `
      );
  
      var inlineQuery = '';
      //console.log(resourcePermistions);
  
      if (resourcePermistions && resourcePermistions[0]) {
        if (resourcePermistions[0].inline_update) {
          resourcePermistions[0].form_mode = 'UiInlineForm';
        
        setState({
          form_mode: resourcePermistions[0].form_mode
         });
        }
  
        if (resourcePermistions[0].inline_update) {
          inlineQuery = 'and is_inline=true';
        }
      }
  
      let tabs = alasql(
        `select distinct write_group as tab from resources where resource_name ='${resource}'  ${inlineQuery} and is_edit_field =true and role_${role}='write' `
      ).map(({ tab }) => tab);
  
      let resourcesFields = alasql(
        `select distinct write_group as tab from resources where resource_name ='${resource}'  ${inlineQuery} `
      ).map(({ tab }) =>
        alasql(`select  watched_column,grid_class,grid_xs,grid_sm,is_require_separator,is_require_label,label_text,source_name, edit_input_widget_type as input_widget_type, field_meta , annotation, css_class, edit_css_class, full_width, is_required  from resources where write_group ="${tab}" and resource_name ='${resource}'  and is_edit_field =true AND ( role_${role}='write' ) ${inlineQuery} `)
      );
  
      let resourcesTabs = alasql(
        `select distinct write_group as tab from resources where resource_name ='${resource}' ${inlineQuery} `
      ).map(({ tab }) =>
        alasql(`select  width_class,new_line_after  from custom_tabs where tab_id ="${tab}" and resource_name ='${resource}'  ${inlineQuery}   `)
      );


      resourcesFields = resourcesFields.filter(d => d.length > 0);
  
      let headerFields = alasql(`select  watched_column,grid_class,grid_xs,grid_sm,is_require_separator,is_require_label,label_text,source_name,edit_input_widget_type as input_widget_type, field_meta , annotation , css_class, edit_css_class, full_width, is_required from resources where  resource_name ='${resource}'  and is_edit_field =true AND ( role_${role}='read' ) and annotation ="header"`);
  
      setState({
        loading: false,
        resourcesFields,
        resourcesTabs,
        resourcePermistions,
        tabs,
        canDelete: false,
      });
    }, []);
  
    const { loading, resourcesFields, resourcesTabs, canDelete, tabs,form_mode } = state;
console.log(form_mode);
    return (
        <EditBase {...props}>
            <Box
                width={{ xs: '100vW', sm: 400 }}
                pt={{ xs: 5, sm: 0 }}
                mt={{ xs: 2, sm: 0 }}
            >
                        {formMap(form_mode, resourcesFields, resourcesTabs, canDelete, tabs, id)}

            </Box>
        </EditBase>
    );
};

export default ReviewEdit;





